<template>
  <SelectFieldWithLoader
    v-if="brandsList"
    v-bind="$attrs"
    :label="translate('generic.brand')"
    :options="brandsOptions"
    search
  />
</template>

<script setup>
import { computed, markRaw } from 'vue'
import { useBrands } from '@/composables/useProfile'
import SelectFieldWithLoader from '@/components/SelectFieldWithLoader.vue'
import useTranslate from '@/composables/useTranslate'

const props = defineProps({
  allowAll: { type: Boolean, default: false },
})

const { translate, translationsLoaded } = useTranslate()

const brandsList = useBrands()

const brandsOptions = computed(() => {
  const loaded = translationsLoaded.value
  const options = brandsList.value.map((brand) => markRaw({
    value: brand,
    label: brand,
  }))
  if (props.allowAll) {
    options.unshift(markRaw({
      value: '',
      label: loaded ? translate('generic.all') : 'All',
    }))
  }
  return markRaw(options)
})
</script>

<script>
export default {
  compatConfig: {
    MODE: 3,
    INSTANCE_LISTENERS: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
  },
  inheritAttrs: false,
}
</script>
